import { render, staticRenderFns } from "./PromotionMaxTotalUses.vue?vue&type=template&id=b6483708&"
import script from "./PromotionMaxTotalUses.vue?vue&type=script&lang=ts&"
export * from "./PromotionMaxTotalUses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports